import { PING_URL } from "@constants/urlConstants";
import message from "@ui_components/Message";
import makeRequest from "@utility/makeRequest";
import translateToLocale from "@utility/translateToLocale";

export const online = () => {
    message.success(translateToLocale("monitorNetwork.connectionRestored", 'Internet connection restored'), Number("5"));
}

export const offline = () => {
    message.error(translateToLocale("monitorNetwork.noConnection", 'No internet connection. Check your connection and try again'), Number("5"));
}

export const checkNetworkStability = () => {
    let lastAlertTime = 0;
    if (typeof window !== "undefined") {
        const interval = setInterval(() => {
            const currentTime = Date.now();
            const elapsedTimeSinceLastAlert = (currentTime - lastAlertTime) / Number("1000");
            if (elapsedTimeSinceLastAlert < Number("120")) {
                return;
            }
            else {
                const startTime = performance.now();
                makeRequest(PING_URL, {}, "GET", "")
                    .then(() => {
                        const endTime = performance.now();
                        const responseTime = (endTime - startTime) / Number("1000");
                        if (responseTime > 1) {
                            message.warning(translateToLocale("monitorNetwork.poorInternetDetected", 'Network instability (packet drops) or poor internet connection detected.'));
                            lastAlertTime = Date.now();
                        }
                    })
                    .catch((error) => {
                        console.error("Error in checking network", error)
                    })
            }
        }, Number("30000"));
        return interval
    }
    else {
        return null
    }
}